/* eslint-disable react-hooks/exhaustive-deps */
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import Layout from "../Layout/Layout";
import logo from "../../logo.svg";
import { Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useAuth } from "../../context/auth";
import { useCart } from "../../context/cart";
import axios from "axios";
import { useCountry } from "../../context/country";
import CountryPhone from "../CountryPhone";
import {
  getPrice,
  getPriceSymbole,
  currencyFormat,
  getLocalCountryData,
  getExchangeRate,
  getCurrentCountry,
  getOnlyPhoneNo,
  getRoundPrice,
  getPriceCurrencyCode,
  calculatePercentage,
  shippingTotal,
  getFormattedFutureDate,
  expressShippingTotal,
} from "../../Helper";
import countryState from "../../countriesStates.json";
import {
  useStripe,
  Elements,
  useElements,
  PaymentElement,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { addCustomerAddressAPI, getCustomerAddressAPI } from "../APIS";
import { useQueryClient, useMutation, useQuery } from "@tanstack/react-query";
import { Typeahead } from "react-bootstrap-typeahead";
import CheckoutForm from "./CheckoutForm";
import IntlTelInputBox from "../login/IntlTelInputBox";
import CurrentLocation from "./CurrentLocation";
import CountdownTimer from "../../pages/CountdownTimer";
//const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK);
export default function CheckoutPhonePe() {
  const [clientSecret, setClientSecret] = useState("");
  const [stripePromise, setStripePromise] = useState(null);
  const [stripePaymentData, setStripePaymentData] = useState({});

  const [typehCountry, setTypehCountry] = useState([]);
  const [typehState, setTypehState] = useState([]);
  const queryClient = useQueryClient();
  const [cart, setCart, updateCart] = useCart();
  const location = useLocation();
  const navigate = useNavigate();
  const [countryCode, setCountryCode] = useCountry();
  const [noCartItem, setNoCartItem] = useState("Loading...");
  const [outOfStock, setOutOfStock] = useState(0);
  const locaCountry = JSON.parse(
    sessionStorage.getItem("country_data")
      ? sessionStorage.getItem("country_data")
      : "{}"
  );
  const { country_code, code, country_name } = locaCountry;
  const symbol = getPriceSymbole();
  const exchange_rate = getExchangeRate();
  const [auth, setAuth] = useAuth();
  const [currentState, setCurrentState] = useState("");
  const [allCountry, setAllCountry] = useState([]);
  let localCountryData = getLocalCountryData();
  const [country, setCountry] = useState(localCountryData?.calling_code);
  const [addressValidated, setAddressValidated] = useState(false);
  const [validated, setValidated] = useState(false);
  const [userId, setUserId] = useState(auth?.user?.id);
  const [products, setProducts] = useState(cart);
  const [loading, setLoading] = useState(false);
  const [totalMrp, setTotalMrp] = useState("");
  const [totalAmount, setTotalAmount] = useState("");
  const [priceNoDiscount, setPriceNoDiscount] = useState(0);
  const [productDiscount, setProductDiscount] = useState(0);
  const [productTax, setProductTax] = useState(0);
  const [productShipping, setProductShipping] = useState(0);
  const [productShippingNormal, setProductShippingNormal] = useState(0);
  const [productShippingExpress, setProductShippingExpress] = useState(0);
  const [coupon, setCoupon] = useState("");
  const [couponData, setCouponData] = useState("");
  const [couponDiscount, setCouponDiscount] = useState(0);
  const [removeCoupon, setRemoveCoupon] = useState(false);
  const [errMsg, setErrMsg] = useState({});
  /* const [adddDropdown, setAdddDropdown] = useState([]); */
  const [selecteAddId, setSelecteAddId] = useState("");
  const [selectedCode, setSelectedCode] = useState(auth?.user.c_code);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [arrayDiscount, setArrayDiscount] = useState([]);

  const [fbPixel, setFbPixel] = useState(0);
  const [fbPixelData, setFbPixelData] = useState({});
  const [activePaymentTab, setActivePaymentTab] = useState("online");
  const [onlineDiscount, setOnlineDiscount] = useState(0);
  const [cod, setCod] = useState(0);
  const [codBalance, setCodBalance] = useState(0);
  const [welcomeDiscountEnable, setWelcomeDiscountEnable] = useState(0);
  const [welcomeDiscountAmount, setWelcomeDiscountAmount] = useState(0);
  const [timeLeft] = useState(() => {
    const storedCountdown = parseInt(localStorage.getItem("countdown"));
    if (!isNaN(storedCountdown)) {
      return storedCountdown;
    }
  });
  const [isDiscountVisible, setIsDiscountVisible] = useState(() => {
    return auth?.user?.welcome_discount_use !== 1;
  });

  const getCountryState = async () => {
    if (countryState.length > 0) {
      const state = countryState
        .filter((item) => item.iso2 === country_code)
        .map((item, i) => item.states);
      const country = countryState.map((item, i) => item.name);
      /* console.log('==>',country) */
      setTypehCountry([country_name]);
      if (state.length > 0) {
        setCurrentState(state[0]);
      }
      if (country.length > 0) {
        setAllCountry(country);
      }
    }
  };

  const getStateByCountry = async (country) => {
    if (countryState.length > 0) {
      const state = countryState
        .filter((item) => item.name === country)
        .map((item, i) => item.states);
      if (state.length > 0) {
        setCurrentState(state[0]);
      }
    }
  };

  const [details, setDetails] = useState({
    customer_id: userId,
    contact_person_name: auth?.user?.name,
    phone: auth?.user?.phone,
    address_type: "",
    c_code: auth?.user.c_code,
    state: "",
    city: "",
    zip: "",
    landmark: "",
    country: country_name,
    address: "",
  });

  const [fullPhone, setFullPhone] = useState(auth?.user?.phone);

  const {
    data: addDropdown,
    isFetched,
    isLoading,
    isError,
    isLoadingError,
  } = useQuery({
    queryKey: ["address", userId],
    queryFn: () => getCustomerAddressAPI(userId),
    staleTime: 5 * 1000,
  });

  useEffect(() => {
    if (addDropdown) {
      setSelecteAddId(addDropdown[0]?.id);
      setStripePaymentData({
        ...stripePaymentData,
        address_id: addDropdown[0]?.id,
      });
    }
  }, [addDropdown]);

  useEffect(() => {
    if (!isDiscountVisible) {
      setWelcomeDiscountAmount(0);
    } else {
      setWelcomeDiscountAmount(Number(totalAmount - productShipping) * 0.05);
    }
  }, [isDiscountVisible, totalAmount]);

  const addAddressMutation = useMutation({
    mutationFn: addCustomerAddressAPI,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["address"] });
      if (data?.status) {
        setSelecteAddId(data?.addresses_id);
        setStripePaymentData({
          ...stripePaymentData,
          address_id: data?.addresses_id,
        });
      }
      setLoading(false);
      setAddrForm("form-hide");
      setBtnForm("btn-show");
      setDetails({
        ...details,
        address_type: "",
        state: "",
        city: "",
        zip: "",
        landmark: "",
        address: "",
      });
    },
  });

  // selectedCode
  const handlePhoneCode = (ph_code) => {
    setDetails({
      ...details,
      c_code: ph_code,
    });
  };

  const changeHandle = async (event) => {
    const form = event.currentTarget;
    let value = event.target.value;
    value = value.trimStart();
    let name = event.target.name;
    if (name === "country") {
      setDetails({
        ...details,
        country: value,
        state: "",
      });
      getStateByCountry(value);
    } else {
      setDetails({
        ...details,
        [name]: value,
      });
    }

    if (name === "payment" && value === "stripe") {
      await paymentIntent();
    }
    /*  console.log(name,value) */
  };

  const handleSubmitAddress = (event) => {
    setLoading(true);
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setLoading(false);
    }
    setAddressValidated(true);
    if (form.checkValidity() === true) {
      addAddressMutation.mutate({ ...details, phone: fullPhone });
    }
  };

  const handleCheckOut = async (event) => {
    try {
      event.preventDefault();
      const form = event.currentTarget;

      if (form.checkValidity() === false) {
        event.stopPropagation();
      }
      setValidated(true);
      if (form.checkValidity() === true) {
        if (outOfStock !== 0) {
          alert("Please check few items are unavailable for checkout!");
          return false;
        }

        if (
          selecteAddId === null ||
          selecteAddId === 0 ||
          selecteAddId === ""
        ) {
          alert("Please save or select delivery address!");
          return false;
        }

        if (Object.keys(fbPixelData).length > 0) {
          if (window.fbq != null) {
            window.fbq("track", "AddPaymentInfo", {
              content_ids: fbPixelData.content_ids,
              content_type: "product",
              value: fbPixelData.value,
              currency: "INR",
              num_items: fbPixelData.num_items,
              custom_param: exchange_rate,
            });
          }
        }

        if (details?.payment === "razorpay") {
          return await displayRazorpay();
        } else if (details?.payment === "stripe") {
          return await displayStripe();
        } else if (details?.payment === "phonepe") {
          //alert('hii');
          return await displayPhonepe();
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getCartData = async () => {
    try {
      setOutOfStock(0);
      const country_data = sessionStorage.getItem("country_data");
      let { data } = await axios.get(
        `${
          process.env.REACT_APP_API_URL
        }/cart?customer_id=${userId}&country_code=${
          JSON.parse(country_data)?.country_code
        }`
      );

      let product = data?.product;
      if (data?.length === 0) {
        setNoCartItem("No Item in the cart");
      } else {
        setNoCartItem("");
      }
      let total_mrp = 0;
      let total_discount = 0;
      let total_shipping = 0;
      let expressShipping = 0;
      let total_tax = 0;
      let price_no_disc = 0;
      let item_name_arr = [];
      data.forEach((item, i) => {
        item_name_arr.push(item.name);
        if (item.product.total_current_stock === 0) {
          setOutOfStock(1);
        }

        if (item.product.total_current_stock > 0) {
          total_mrp = total_mrp + item.price * item.quantity;
          total_discount = total_discount + item.discount * item.quantity;
          //total_shipping = total_shipping + item.shipping_cost;
          total_shipping = total_shipping + shippingTotal(item.shipping);
          total_tax = total_tax + item.tax * item.quantity;
          expressShipping =
            expressShipping + expressShippingTotal(item.shipping);
          if (item.discount === 0) {
            price_no_disc = price_no_disc + item.price * item.quantity;
          }
        }
      });

      //total_discount = getRoundPrice(total_discount);
      setProducts(data);
      setTotalMrp(total_mrp);
      setProductDiscount(total_discount);
      setProductTax(total_tax);
      setProductShipping(total_shipping);
      setProductShippingExpress(expressShipping);
      setProductShippingNormal(total_shipping);

      setPriceNoDiscount(price_no_disc);
      //  setTotalAmount(total_mrp+total_tax+total_shipping-(total_discount+couponDiscount));
      if (price_no_disc === 0) {
        setTotalAmount(total_mrp + total_tax + total_shipping - total_discount);
      } else {
        setTotalAmount(
          total_mrp +
            total_tax +
            total_shipping -
            (total_discount + couponDiscount)
        );
      }
      if (data?.length > 0) {
        setStripePromise(loadStripe(process.env.REACT_APP_STRIPE_PK));
      }
      setLoading(false);

      // for fb pixel
      setFbPixelData({
        content_ids: item_name_arr,
        value: total_mrp,
        num_items: item_name_arr.length,
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (Object.keys(fbPixelData).length > 0 && fbPixel === 0) {
      if (window.fbq != null) {
        window.fbq("track", "InitiateCheckout", {
          content_ids: fbPixelData.content_ids,
          content_type: "product",
          value: fbPixelData.value,
          currency: "INR",
          num_items: fbPixelData.num_items,
          custom_param: exchange_rate,
        });
      }
      setFbPixel(1);
    }
  }, [fbPixelData]);

  const handleRemove = async (id) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to remove this item?"
    );
    if (isConfirmed) {
      try {
        setErrMsg({});
        setCoupon("");
        setCouponDiscount(0);
        setPriceNoDiscount(0);
        //setTotalAmount(totalMrp);
        setLoading(true);
        let { data } = await axios.delete(
          `${process.env.REACT_APP_API_URL}/cart/remove?id=${id}&customer_id=${userId}`
        );
        //console.log(data)
        updateCart(userId);
        await getCartData();
        setDetails({
          ...details,
          payment: "",
        });
        setLoading(false);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleAdd = async (id, newQty) => {
    try {
      setErrMsg({});
      setCoupon("");
      setCouponDiscount(0);
      //setTotalAmount(totalMrp);
      setLoading(true);
      let temp_product = products
        .filter((item, index) => item.id == id)
        .map((item) => item.quantity);
      let { data } = await axios.put(
        `${process.env.REACT_APP_API_URL}/cart/update`,
        { customer_id: userId, quantity: temp_product[0] + newQty, id: id }
      );
      updateCart(userId);
      //console.log(data)
      await getCartData();
      setDetails({
        ...details,
        payment: "",
      });
      setLoading(false);
      if (!data?.status) {
        alert(data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleCoupon = async () => {
    setErrMsg({});
    setCouponDiscount(0);
    //setTotalAmount(totalMrp)
    setRemoveCoupon(false);
    try {
      setLoading(true);
      if (priceNoDiscount === 0) {
        setLoading(false);
        setErrMsg({
          cls: "alert alert-danger",
          msg: "Coupon code is not applicable for sale items.",
        });
        return;
      }
      if (coupon === "" || coupon.trim() === "") {
        setLoading(false);
        setErrMsg({
          cls: "alert alert-danger",
          msg: "Coupon code is required",
        });
        return;
      } else {
        //setLoading(true);
        let { data } = await axios.get(
          `${process.env.REACT_APP_API_URL}/coupon/apply?customer_id=${userId}&code=${coupon}`
        );
        setLoading(false);
        if (data.status) {
          //console.log(data);
          let coupnaData = data?.coupon;
          if (coupnaData.min_purchase > totalMrp) {
            setErrMsg({
              cls: "alert alert-danger",
              msg: `Can not apply coupon code, minimum purchase amount must be ${coupnaData.min_purchase} or greater.`,
            });
            return;
          } else if (coupnaData.min_purchase <= totalMrp) {
            setCouponData(coupnaData.coupon);
            let discount = coupnaData.discount;
            let max_discount = coupnaData.max_discount;
            let discount_type = coupnaData.discount_type;
            if (discount_type === "amount") {
              setCouponDiscount(max_discount);
            } else if (discount_type === "percentage") {
              //let cop_disc = ((totalMrp*discount)/100);
              let cop_disc = (priceNoDiscount * discount) / 100;
              if (cop_disc > max_discount) {
                cop_disc = max_discount;
              }

              setCouponDiscount(cop_disc);
              setTotalAmount(
                totalMrp +
                  productTax +
                  productShipping -
                  (productDiscount + cop_disc)
              );
            }
          }
        } else if (!data.status) {
          setErrMsg({ cls: "alert alert-danger", msg: data?.message });
        }
        setDetails({
          ...details,
          payment: "",
        });
        return;
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleRemoveCoupon = async () => {
    /* const[removeCoupon, setRemoveCoupon] = useState(false); */
    //setLoading(true)
    setCouponDiscount(0);
    setCoupon("");
    setCouponData("");
    setTotalAmount("");
    setRemoveCoupon(true);
    setPriceNoDiscount(0);
    setDetails({
      ...details,
      payment: "",
    });
    //await getCartData();
    //setLoading(false)
  };

  const getPaymentMethods = async () => {
    let payMethods = [];
    let { data } = await axios.get(
      `${process.env.REACT_APP_API_URL}/payment-method`
    );
    //console.log('payment data', data);
    for (const [key, value] of Object.entries(data.paymentmethod)) {
      payMethods.push(key);
    }
    setPaymentMethods(payMethods);
    setArrayDiscount(data.codrange);
  };
  //console.log(paymentMethods)

  const paymentIntent = async () => {
    if (products.length > 0) {
      const data_payment = {
        products: products,
        customer_id: userId,
        currency_code: code,
        currency: symbol,
        total_price: getPrice(
          totalAmount - onlineDiscount - welcomeDiscountAmount,
          false
        ),
        order_amount: getPrice(
          totalAmount - onlineDiscount - welcomeDiscountAmount,
          false
        ),
        exchange_rate: exchange_rate,
        coupon_code: couponDiscount > 0 ? coupon : "",
        coupon_discount: getPrice(couponDiscount, false),
        address_id: selecteAddId,
      };

      const { data } = await axios.post(
        `${process.env.REACT_APP_API_URL}/payment/create_payment_intent`,
        data_payment
      );
      if (data?.status) {
        setStripePaymentData({
          ...data_payment,
          total_price: getRoundPrice(
            totalAmount - onlineDiscount - welcomeDiscountAmount
          ),
          order_amount: getRoundPrice(
            totalAmount - onlineDiscount - welcomeDiscountAmount
          ),
          coupon_discount: getRoundPrice(couponDiscount),
        });
        setClientSecret(data?.client_secret);
      }
    }
  };
  const getWelComeDiscount = async () => {
    let { data } = await axios.get(
      `${process.env.REACT_APP_API_URL}/static/welcomediscount`
    );
    if (data?.status) {
      setWelcomeDiscountEnable(data?.status);
    }
  };
  useEffect(() => {
    if (userId) {
      getWelComeDiscount();
    }
    //eslint-disable-next-line
  }, [userId]);
  useEffect(() => {
    setLoading(true);
    updateCart(userId);
    getCartData();
    getCountryState();
    getPaymentMethods();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (removeCoupon) {
      setLoading(true);
      getCartData();
    }
    //eslint-disable-next-line
  }, [removeCoupon]);

  useEffect(() => {
    //setLoading(true);
    setTimeout(() => {
      getCartData();
    }, 2000);
    //eslint-disable-next-line
  }, [cart]);

  /* start PhonePe */
  // Stript integration
  const displayPhonepe = async () => {
    setLoading(true);
    const body = {
      products: products,
      customer_id: userId,
      currency_code: code,
      currency: symbol,
      total_price: getPrice(
        totalAmount - onlineDiscount - welcomeDiscountAmount,
        false
      ),
      order_amount: getRoundPrice(
        totalAmount - onlineDiscount - welcomeDiscountAmount
      ),
      exchange_rate: exchange_rate,
      coupon_code: couponDiscount > 0 ? coupon : "",
      coupon_discount: getRoundPrice(couponDiscount),
      address_id: selecteAddId,
      success_url: `${window.location.origin}/phonepe-payment-success`,
      cancel_url: window.location.href,
      cod: cod,
      cod_balance: codBalance,
      extra_discount: getRoundPrice(onlineDiscount),
      welcome_discount: getRoundPrice(welcomeDiscountAmount),
      shipping_cost: productShipping,
    };
    const headers = { "Content-Type": "application/json" };
    const resp = await fetch(
      `${process.env.REACT_APP_API_URL}/payment/pay_phonepe`,
      { method: "POST", headers: headers, body: JSON.stringify(body) }
    );
    const res = await resp.json();
    if (
      res.success &&
      res.data &&
      res.data.instrumentResponse.redirectInfo.url
    ) {
      if (typeof window !== "undefined") {
        if (window.fbq != null) {
          window.fbq("track", "Purchase", {
            value: totalAmount - onlineDiscount - welcomeDiscountAmount,
            currency: "INR",
          });
        }
      }

      window.location.href = res.data.instrumentResponse.redirectInfo.url;
    } else {
      setLoading(false);
      console.log(res);
    }
  };
  /* end PhonePay */

  function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }

  const displayRazorpay = async () => {
    setLoading(true);
    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
      setLoading(false);
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }

    const result = await axios.post(
      `${process.env.REACT_APP_API_URL}/payment/orders`,
      {
        amount: getPrice(
          totalAmount - onlineDiscount - welcomeDiscountAmount,
          false
        ),
        currency: code,
      }
    );
    if (!result) {
      setLoading(false);
      alert("Server error. Are you online?");
      return;
    }

    const { amount, order_id, currency } = result.data;
    const options = {
      key: process.env.RAZORPAY_KEY_ID, // Enter the Key ID generated from the Dashboard --Live
      //key: "rzp_test_G9Y0adnL7VlQJp", // Enter the Key ID generated from the Dashboard  --Sanjeev.kumar@eyeforweb.com
      amount: amount.toString(),
      currency: currency,
      name: "chaashnicouture.com",
      description: "Chaashnicouture payment",
      image: { logo },
      order_id: order_id,
      handler: async function (response) {
        const dataArr = {
          coupon_code: couponDiscount > 0 ? coupon : "",
          coupon_discount: getRoundPrice(couponDiscount),
          address_id: selecteAddId,
          order_id: order_id,
          customer_id: userId,
          razorpay_payment_id: response.razorpay_payment_id,
          razorpayOrderId: response.razorpay_order_id,
          razorpaySignature: response.razorpay_signature,
          currency: symbol,
          order_amount: getRoundPrice(
            totalAmount - onlineDiscount - welcomeDiscountAmount
          ),
          exchange_rate: exchange_rate,
          cod: cod,
          cod_balance: codBalance,
          extra_discount: getRoundPrice(onlineDiscount),
          welcome_discount: getRoundPrice(welcomeDiscountAmount),
          shipping_cost: productShipping,
        };
        if (response?.razorpay_payment_id === "") {
          alert("Payment failed");
          return false;
        }
        setLoading(true);
        const { data } = await axios.post(
          `${process.env.REACT_APP_API_URL}/payment/success`,
          dataArr
        );
        //console.log(data)
        if (data?.status) {
          localStorage.removeItem("cart");
          setCart([]);
          setLoading(false);
          const o_id = data?.order_ids[0];

          if (typeof window !== "undefined") {
            if (window.fbq != null) {
              window.fbq("track", "Purchase", {
                value: totalAmount - onlineDiscount - welcomeDiscountAmount,
                currency: "INR",
              });
            }
          }

          navigate(`/myorders?order=1&o_id=${o_id}`);
          return;
        } else {
          alert(data?.msg);
          location.reload();
        }
      },
      prefill: {
        name: details.contact_person_name,
        email: auth?.user.email,
        contact: details.phone,
      },
      notes: {
        address: details.address,
      },
      theme: {
        color: "#61dafb",
      },
    };

    const paymentObject = new window.Razorpay(options);
    setLoading(false);
    paymentObject.open();
  };

  // Stript integration
  const displayStripe = async () => {
    setLoading(true);
    const stripe = await loadStripe(process.env.REACT_APP_STRIPE_PK);
    const body = {
      products: products,
      customer_id: userId,
      currency_code: code,
      currency: symbol,
      total_price: getPrice(
        totalAmount - onlineDiscount - welcomeDiscountAmount,
        false
      ),
      order_amount: getRoundPrice(
        totalAmount - onlineDiscount - welcomeDiscountAmount
      ),
      exchange_rate: exchange_rate,
      coupon_code: couponDiscount > 0 ? coupon : "",
      coupon_discount: getRoundPrice(couponDiscount),
      address_id: selecteAddId,
      success_url: `${window.location.origin}/payment-success`,
      cancel_url: window.location.href,
      cod: cod,
      cod_balance: codBalance,
      extra_discount: getRoundPrice(onlineDiscount),
      welcome_discount: getRoundPrice(welcomeDiscountAmount),
      shipping_cost: productShipping,
    };
    const headers = { "Content-Type": "application/json" };
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/payment/pay-stripe`,
      { method: "POST", headers: headers, body: JSON.stringify(body) }
    );

    /* console.log(response); return false; */
    const session = await response.json();
    setLoading(false);

    if (typeof window !== "undefined") {
      if (window.fbq != null) {
        window.fbq("track", "Purchase", {
          value: totalAmount - onlineDiscount - welcomeDiscountAmount,
          currency: "INR",
        });
      }
    }

    const result = stripe.redirectToCheckout({
      sessionId: session.id,
    });

    console.log(result);
    if (result.error) {
      console.log(result.error);
    }
  };

  const [addrForm, setAddrForm] = useState("form-hide");
  const [btnForm, setBtnForm] = useState("btn-show");

  const handleAddForm = () => {
    setAddrForm("show-form");
    setBtnForm("btn-hide");
  };

  const handleCountryChange = (selected) => {
    if (selected.length > 0) {
      let cur_country = selected[0];
      setDetails({
        ...details,
        country: cur_country,
      });
      getStateByCountry(cur_country);
      setTypehState([]);
    }
  };

  const handleStateChange = (selected) => {
    if (selected.length > 0) {
      let cur_state = selected[0]["name"];
      setDetails({
        ...details,
        state: cur_state,
      });
    }
  };

  const [intelValid, setIntelValid] = useState("");
  const handleIntel = (dv) => {
    setIntelValid(dv);
  };

  useEffect(() => {
    if (countryCode.country_code === "IN") {
      if (activePaymentTab === "online") {
        //setOnlineDiscount(Number(totalAmount - productShipping) * 0.05);      
        setCod(0);
        setCodBalance(0);
      } else {
        /* setOnlineDiscount(
          (totalAmount - welcomeDiscountAmount) *
            calculatePercentage(totalAmount, arrayDiscount).remaining
        ); */
        setCod(1);
        setCodBalance(
          totalAmount -
            welcomeDiscountAmount -
            (totalAmount -
              getRoundPrice(onlineDiscount) -
              getRoundPrice(welcomeDiscountAmount))
        );
        //setTotalAmount(totalMrp * 0.5);
      }
    }
  }, [activePaymentTab, totalAmount, cod]);

  const [selectedShipping, setSelectedShipping] = useState("");
  const handleSetShippingAmount = (amount) => {
    setProductShipping(amount);
    setSelectedShipping(amount);
    setTotalAmount(totalMrp + productTax + amount - productDiscount);
  };

  useEffect(() => {
    if (productShippingNormal > 0) {
      setSelectedShipping(productShippingNormal);
    }
  }, [productShippingNormal]);

  //console.log(totalAmount, onlineDiscount)
  return (
    <Layout title="Checkout | Chaashni Couture">
      <div
        className={`site-content-wrap checkout-content-wrap ${
          loading ? "loading" : ""
        }`}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-7 col-md-12">
              <h1 className="sustom-heading-h1">
                CHECKOUT AND <span>PAY</span>
              </h1>
              <div className="content-box">
                {/* clientSecret */}
                {addDropdown?.length > 0 ? (
                  <div className="checkout-section address-wrap">
                    <h2 className="has-add">Delivery Address</h2>
                    <ul>
                      {addDropdown?.map((e, i) => (
                        <li key={i}>
                          <label className="address-box">
                            <div className="address-checkbox">
                              <input
                                type="radio"
                                name="shipping_address"
                                onClick={() => {
                                  setSelecteAddId(e.id);
                                  setStripePaymentData({
                                    ...stripePaymentData,
                                    address_id: e.id,
                                  });
                                }}
                                value={e.id}
                                checked={selecteAddId === e.id ? true : false}
                              />
                            </div>
                            <div className="address-place fw-bold">
                              <span>{e.address_type}</span>
                            </div>
                            <div className="address-name">
                              {e.contact_person_name}
                            </div>
                            <div className="address-name">{e.phone}</div>
                            <div className="address-detail">
                              {e.address}, {e.city}, {e.state} - {e.zip},{" "}
                              {e.country}
                            </div>
                          </label>
                        </li>
                      ))}
                    </ul>
                  </div>
                ) : (
                  ""
                )}

                {addDropdown?.length > 0 ? (
                  <button
                    onClick={handleAddForm}
                    className={`btn-primary btn ${btnForm}`}
                  >
                    + Add Address
                  </button>
                ) : (
                  ""
                )}

                <Form
                  noValidate
                  validated={addressValidated}
                  onSubmit={handleSubmitAddress}
                  className={`${
                    addDropdown?.length === 0 ? "open-form" : addrForm
                  }`}
                >
                  <div className="checkout-section">
                    <h2 className="has-add">Personal Details*</h2>
                    <ul>
                      <li>
                        <input
                          type="text"
                          name="contact_person_name"
                          className="form-control"
                          required
                          placeholder="Contact person name"
                          value={details.contact_person_name}
                          onChange={changeHandle}
                        />
                      </li>
                      {/*
                                <li className="country-code"><CountryPhone code={details.c_code} selectedCode={handlePhoneCode}/></li>
                                <li className="phone-no"><input type='text' className="form-control" name="phone" required placeholder='Phone No.' value={details.phone} onChange={changeHandle} /></li>
                                */}
                      <li className="phone-no">
                        <div className="login-data mobile-field">
                          {details?.phone && (
                            <IntlTelInputBox
                              setFullPhone={setFullPhone}
                              selectedPhone={fullPhone}
                              handleIntel={handleIntel}
                            />
                          )}
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="checkout-section">
                    <h2 className="has-add jio-location-wrap">
                      Shipping Address*{" "}
                      <CurrentLocation
                        setTypehState={setTypehState}
                        setDetails={setDetails}
                      />
                    </h2>

                    <ul>
                      <li className="col-25">
                        <input
                          type="text"
                          name="address_type"
                          value={details.address_type}
                          placeholder="Address Type"
                          className="form-control"
                          required
                          onChange={changeHandle}
                        />
                        <span className="small-text">Eg. Home, Office</span>
                      </li>

                      <li className="col-25">
                        <Typeahead
                          inputProps={{ required: true }}
                          id="basic-typeahead-single"
                          labelKey="name"
                          onChange={(selected) => {
                            handleCountryChange(selected);
                            setTypehCountry(selected);
                          }}
                          options={allCountry}
                          placeholder="Choose a country..."
                          selected={typehCountry}
                        />

                        {/*
                                      <select className="form-control" required name="country" defaultValue={details.country} value={details.country} onChange={changeHandle}>
                                      <option value="">--Select Country--</option>
                                      {allCountry.length>0 && allCountry?.map((e,i)=>(
                                        <option key={i} value={e}>{e}</option>
                                      ))}
                                      </select>
                                    */}
                      </li>

                      <li className="col-25">
                        <Typeahead
                          inputProps={{ required: true }}
                          id="basic-typeahead-single"
                          labelKey="name"
                          onChange={(selected) => {
                            handleStateChange(selected);
                            setTypehState(selected);
                          }}
                          options={currentState}
                          placeholder="Choose a state..."
                          selected={typehState}
                        />

                        {/*
                                      <select className="form-control" required name="state" defaultValue={''} value={details.state} onChange={changeHandle}>
                                    <option value="">--Select State--</option>
                                    {currentState.length>0 && currentState?.map((e,i)=>(
                                      <option key={i} value={e.name}>{e.name}</option>
                                    ))}
                                    </select>
                                    */}
                      </li>

                      <li className="col-25">
                        <input
                          type="text"
                          className="form-control"
                          name="city"
                          required
                          placeholder="City"
                          value={details.city}
                          onChange={changeHandle}
                        />
                      </li>
                      <li className="col-25">
                        <input
                          type="text"
                          className="form-control"
                          name="zip"
                          required
                          placeholder="Zipcode"
                          value={details.zip}
                          onChange={changeHandle}
                        />
                      </li>
                      <li className="col-75">
                        <input
                          type="text"
                          className="form-control"
                          name="landmark"
                          placeholder="Landmark"
                          value={details.landmark}
                          onChange={changeHandle}
                        />
                      </li>
                      <li className="col-75">
                        <input
                          type="text"
                          className="form-control"
                          name="address"
                          required
                          placeholder="Address"
                          value={details.address}
                          onChange={changeHandle}
                        />
                      </li>
                      <li className="col-25">
                        <button type="submit" className="btn btn-primary">
                          Save Address
                        </button>
                      </li>
                    </ul>
                  </div>
                </Form>
                <div className="checkout-box-text">
                  <ul>
                    <li className="heading-li">Please note:</li>
                    <li>
                      Shipping details, including the name and mobile number,
                      can be different from the account holder's details.
                    </li>
                    <li>Shipping details can be different for each order.</li>
                    <li>
                      Shipping details cannot be different for different items
                      in a particular order.
                    </li>
                    <li>
                      For any change of shipping details after you have placed
                      an order, please{" "}
                      <Link
                        target="_blank"
                        to={`mailto:${process.env.REACT_APP_EMAIL_ID}`}
                      >
                        write to us
                      </Link>{" "}
                      as soon as possible.
                    </li>
                    <li>
                      Our help gets restricted after the order is dispatched.
                    </li>
                  </ul>
                  <p>
                    For more information, please refer to:{" "}
                    <Link target="_blank" to="/pages/terms-conditions">
                      Terms and Conditions
                    </Link>{" "}
                    and{" "}
                    <Link target="_blank" to={"/pages/shipping-information"}>
                      Shipping Information
                    </Link>
                    .
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-5 col-md-12">
              {products.length > 0
                ? couponDiscount === 0 && (
                    <div className="coupon-code">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Coupon code"
                        value={coupon}
                        onChange={(e) => setCoupon(e.target.value)}
                      />
                      <button
                        type="button"
                        className="button"
                        onClick={handleCoupon}
                      >
                        Apply coupon
                      </button>
                      {errMsg.cls ? (
                        <p className={errMsg.cls}>{errMsg.msg}</p>
                      ) : (
                        ""
                      )}
                    </div>
                  )
                : ""}

              <div className="custom-cart-payment-box">
                <h3 className="cart-heading">
                  {" "}
                  {products.length > 0
                    ? `ORDER SUMMARY (${products.length} Items)`
                    : ""}{" "}
                </h3>

                {products.length > 0 ? (
                  <>
                    <div className="cart-table">
                      <table className="onestepcheckout-summary">
                        <thead>
                          <tr>
                            <th className="thumb">Product</th>
                            <th className="qty">Quantity</th>
                            <th className="total">Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          {products?.map((item, i) => (
                            <tr key={i}>
                              <td className="thumb">
                                <div className="product-box-wrap">
                                  <div className="left-box">
                                    <Link
                                      to={`/product/${item.slug}`}
                                      target="_blank"
                                    >
                                      <img
                                        className="attachment-woocommerce_thumbnail size-woocommerce_thumbnail"
                                        src={`${process.env.REACT_APP_IMAGE_URL}/product/thumbnail/${item.thumbnail}`}
                                        alt={item.name}
                                        title={item.name}
                                      />
                                    </Link>
                                  </div>

                                  <div className="right-box">
                                    <h2>{item.name}</h2>
                                    <h6 className="sku-box">
                                      Item Code: {item.code}
                                    </h6>
                                    {Object.entries(item?.variations).map(
                                      ([keydata, subject], i) => (
                                        <>
                                          <h6 className="product-size" key={i}>
                                            {keydata}:{" "}
                                            {subject === "CUSTOMTAILORED"
                                              ? subject.replace(
                                                  "CUSTOM",
                                                  "CUSTOM "
                                                )
                                              : subject}
                                          </h6>
                                          {subject === "CUSTOMTAILORED" ? (
                                            <span className="tailor-text text-success">
                                              After the order is successfully
                                              placed, we will get in touch to
                                              seek your measurements.
                                            </span>
                                          ) : (
                                            ""
                                          )}
                                        </>
                                      )
                                    )}

                                    {item.product?.total_current_stock > 0 ? (
                                      <div className="price-box">
                                        {item.discount !== 0 ? (
                                          <span className="del">
                                            {symbol} {getPrice(item.price)}
                                          </span>
                                        ) : (
                                          ""
                                        )}

                                        <span className="price">
                                          {symbol}{" "}
                                          {getPrice(item.price - item.discount)}
                                        </span>
                                      </div>
                                    ) : (
                                      <div className="text-danger out-of-stock">
                                        Out Of Stock
                                      </div>
                                    )}

                                    <div className="remove-box">
                                      <Link
                                        onClick={() => {
                                          handleRemove(item.id);
                                        }}
                                      >
                                        <i
                                          className="fa-regular fa-trash-can"
                                          title="Delete"
                                        ></i>
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </td>

                              {item.product?.total_current_stock > 0 ? (
                                <>
                                  <td className="cclw_qty">
                                    <div className="wrapper_qty">
                                      <button
                                        type="button"
                                        className="cclwminus"
                                        disabled={
                                          item.quantity === 1 ? "disabled" : ""
                                        }
                                        onClick={() => {
                                          handleAdd(item.id, -1);
                                        }}
                                      >
                                        -
                                      </button>
                                      <input
                                        type="number"
                                        className="input-text qty text"
                                        min="1"
                                        max={item.product.total_current_stock}
                                        readOnly
                                        title="Qty"
                                        value={item.quantity}
                                      />
                                      <button
                                        type="button"
                                        className="cclwplus"
                                        onClick={() => {
                                          handleAdd(item.id, 1);
                                        }}
                                      >
                                        +
                                      </button>
                                    </div>
                                  </td>
                                  <td className="total">
                                    <span className="del">
                                      {symbol}
                                      {getPrice(
                                        item.price * item.quantity -
                                          item.discount * item.quantity
                                      )}
                                    </span>
                                  </td>
                                </>
                              ) : (
                                <>
                                  <td className="cclw_qty"></td>
                                  <td className="total"></td>
                                </>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    <div className="extra-box">
                      <div className="wishlist-add">
                        <Link to={"/wishlist"}>
                          ADD MORE ITEMS FROM WISHLIST{" "}
                          <i className="fa fa-heart" aria-hidden="true"></i>
                        </Link>
                      </div>
                    </div>

                    <div className="cart_totals">
                      <div className="cart-subtotal">
                        <p className="left-corner"> Total MRP </p>
                        <span className="right-corner">
                          {" "}
                          <span className="price-amount">
                            {currencyFormat(symbol, getPrice(totalMrp))}
                          </span>{" "}
                        </span>
                      </div>

                      <div className="shipping-total">
                        <p className="left-corner"> Shipping </p>
                        <span className="right-corner">
                          {productShipping > 0
                            ? currencyFormat(symbol, getPrice(productShipping))
                            : "Free shipping"}
                        </span>
                      </div>

                      {productDiscount > 0 && (
                        <div className="cart-subtotal red-text">
                          <p className="left-corner"> Discount </p>
                          <span className="right-corner">
                            {" "}
                            <span className="price-amount">
                              -{" "}
                              {currencyFormat(
                                symbol,
                                getPrice(productDiscount)
                              )}
                            </span>
                          </span>
                        </div>
                      )}

                      {couponDiscount > 0 && (
                        <div className="shipping-total red-text">
                          <p className="left-corner"> Coupon Discount </p>
                          <span className="right-corner">
                            - {symbol}
                            {getPrice(couponDiscount)}{" "}
                            <Link onClick={handleRemoveCoupon}>
                              <i
                                className="fa fa-trash text-danger"
                                aria-hidden="true"
                              ></i>
                            </Link>
                          </span>
                        </div>
                      )}
                      {/* {welcomeDiscountEnable === 1 && welcomeDiscountAmount > 0 && timeLeft > 0 && (
                        <div className="shipping-total">
                          <p className="left-corner"> Welcome Discount (5%)</p>
                          <span className="right-corner">
                              - {symbol} {" "} {getPrice(welcomeDiscountAmount)}
                            </span>
                        </div>
                      )} */}

                      {welcomeDiscountEnable === 1 &&
                        timeLeft > 0 &&
                        isDiscountVisible && (
                          <>
                            <div className="shipping-total red-text">
                              <p className="left-corner">
                                {" "}
                                Tik Tok Discount (5%)
                              </p>
                              <span className="right-corner">
                                - {symbol} {getPrice(welcomeDiscountAmount)}
                              </span>
                            </div>

                            <div className="shipping-timer">
                              <div>
                                <span>
                                  Get 5% additional off before the timer runs
                                  out:{" "}
                                </span>
                                <span
                                  style={{
                                    animation: "blink 1s linear infinite",
                                  }}
                                >
                                  <CountdownTimer
                                    initialSeconds={3600}
                                    onComplete={() =>
                                      setIsDiscountVisible(false)
                                    }
                                    storageKey="countdown"
                                  />{" "}
                                </span>
                              </div>
                              <span></span>
                            </div>
                          </>
                        )}

                      {activePaymentTab !== "" &&
                        activePaymentTab === "online" &&
                        countryCode.country_code === "IN" && (
                          <div className="shipping-total red-text online-discount" style={{display: 'none' }}>
                            <p className="left-corner">
                              {" "}
                              Online Payment Discount (5%)
                            </p>
                            <span className="right-corner">
                              - {symbol} {getPrice(Number(totalAmount - productShipping) * 0.05)}
                            </span>
                          </div>
                        )}

                      <div className="order-total">
                        <p className="left-corner"> Total Amount</p>
                        <span className="right-corner">
                          <strong>
                            <span className="price-amount">
                              {activePaymentTab !== "" &&
                              activePaymentTab === "online" &&
                              countryCode.country_code === "IN"
                                ? currencyFormat(
                                    symbol,
                                    getPrice(
                                      totalAmount -
                                        onlineDiscount -
                                        welcomeDiscountAmount
                                    )
                                  )
                                : currencyFormat(
                                    symbol,
                                    getPrice(
                                      totalAmount - welcomeDiscountAmount
                                    )
                                  )}

                              {activePaymentTab !== "" &&
                                activePaymentTab === "pcod" &&
                                countryCode.country_code === "IN" && (
                                  <>
                                    <br />
                                    <small>
                                      (Pay{" "}
                                      {currencyFormat(
                                        symbol,
                                        getPrice(
                                          (totalAmount -
                                            welcomeDiscountAmount) *
                                            calculatePercentage(
                                              totalAmount,
                                              arrayDiscount
                                            ).deducted
                                        )
                                      )}{" "}
                                      now &{" "}
                                      {currencyFormat(
                                        symbol,
                                        getPrice(
                                          totalAmount -
                                            welcomeDiscountAmount -
                                            Math.round(
                                              (totalAmount -
                                                welcomeDiscountAmount) *
                                                calculatePercentage(
                                                  totalAmount,
                                                  arrayDiscount
                                                ).deducted
                                            )
                                        )
                                      )}{" "}
                                      on delivery)
                                    </small>
                                  </>
                                )}
                            </span>
                          </strong>
                        </span>
                      </div>
                    </div>

                    <Form
                      noValidate
                      validated={validated}
                      onSubmit={handleCheckOut}
                    >
                      {countryCode.country_code === "IN" && (
                        <div className="payment-tab">
                          <h3>Payment Options:</h3>
                          <div className="payment-radio">
                            <label>
                              <input
                                type="radio"
                                checked={`${
                                  activePaymentTab === "online" ? "1" : "0"
                                }`}
                                name="payment-opt"
                                onClick={() => setActivePaymentTab("online")}
                              />{" "}
                              <span>
                                Get Additional 5% (
                                {currencyFormat(
                                  symbol,
                                  getPrice(Number(totalAmount - productShipping) * 0.05)
                                )}
                                ) Discount
                              </span>{" "}
                              with 100% Prepaid Payments
                            </label>
                          </div>
                          <div className="payment-radio">
                            <label>
                              <input
                                type="radio"
                                checked={`${
                                  activePaymentTab === "pcod" ? "1" : ""
                                }`}
                                name="payment-opt"
                                onClick={() => setActivePaymentTab("pcod")}
                              />{" "}
                              <strong>
                                Pay{" "}
                                {currencyFormat(
                                  symbol,
                                  getPrice(
                                    (totalAmount - welcomeDiscountAmount) *
                                      calculatePercentage(
                                        totalAmount,
                                        arrayDiscount
                                      ).deducted
                                  )
                                )}{" "}
                                now,
                              </strong>{" "}
                              balance on delivery{" "}
                            </label>
                          </div>
                        </div>
                      )}
                      {productShipping > 0 && (
                        <div className="payment-tab shipping-tab">
                          <h3>Shipping Options:</h3>

                          <div className="payment-radio">
                            <label>
                              <input
                                type="radio"
                                checked={
                                  selectedShipping === productShippingNormal
                                }
                                onClick={() =>
                                  handleSetShippingAmount(productShippingNormal)
                                }
                                name="shipping-opt"
                              />
                              Normal Shipping:{" "}
                              {currencyFormat(
                                symbol,
                                getPrice(productShippingNormal)
                              )}{" "}
                              <small>
                                (Arrives: {getFormattedFutureDate(15)})
                              </small>
                            </label>
                          </div>

                          <div className="payment-radio">
                            <label>
                              <input
                                type="radio"
                                checked={
                                  selectedShipping === productShippingExpress
                                }
                                onClick={() =>
                                  handleSetShippingAmount(
                                    productShippingExpress
                                  )
                                }
                                name="shipping-opt"
                              />
                              Express Shipping:{" "}
                              {currencyFormat(
                                symbol,
                                getPrice(productShippingExpress)
                              )}{" "}
                              <small>
                                (Arrives: {getFormattedFutureDate(7)})
                              </small>
                            </label>
                          </div>
                        </div>
                      )}
                      <div className="payment-wrap">
                        <ul>
                          {paymentMethods?.includes("razor_pay") ? (
                            <li>
                              <label
                                style={{
                                  backgroundImage:
                                    "url(/images/rzp_payment_icon.svg)",
                                }}
                              >
                                <input
                                  type="radio"
                                  required
                                  name="payment"
                                  onChange={changeHandle}
                                  value="razorpay"
                                  className="form-check-input"
                                />
                                <span>UPI/Cards/NetBanking/Wallet</span>
                              </label>
                            </li>
                          ) : (
                            ""
                          )}
                          {paymentMethods?.includes("phonePay") ? (
                            <li>
                              <label
                                style={{
                                  backgroundImage: "url(/images/phonePay.svg)",
                                }}
                              >
                                <input
                                  type="radio"
                                  required
                                  name="payment"
                                  onChange={changeHandle}
                                  value="phonepe"
                                  className="form-check-input"
                                  checked={
                                    details?.payment === "phonepe"
                                      ? true
                                      : false
                                  }
                                />
                                <span>UPI</span>
                              </label>
                            </li>
                          ) : (
                            ""
                          )}
                          {paymentMethods?.includes("stripe") ? (
                            <li>
                              <label
                                style={{
                                  backgroundImage:
                                    "url(/images/stripe-logo.svg)",
                                }}
                              >
                                <input
                                  type="radio"
                                  required
                                  name="payment"
                                  onChange={changeHandle}
                                  value="stripe"
                                  className="form-check-input"
                                  checked={
                                    details?.payment === "stripe" ? true : false
                                  }
                                />
                                <span>Credit Card</span>
                              </label>
                            </li>
                          ) : (
                            ""
                          )}
                        </ul>
                        <div className="invalid-feedback">
                          You must select payment method before submitting.
                        </div>
                      </div>

                      <div
                        className={`${
                          details?.payment === "stripe"
                            ? "form-hide"
                            : "placeorder-btn"
                        }`}
                      >
                        <div className="term-condition">
                          <div className="form-check">
                            <input
                              required
                              name="agreement"
                              type="checkbox"
                              className="form-check-input"
                            />
                            <label className="form-check-label">
                              I have read and agree to the website's{" "}
                            </label>
                            <Link target="_blank" to="/pages/terms-conditions">
                              {" "}
                              Terms and Conditions
                            </Link>{" "}
                            and{" "}
                            <Link
                              target="_blank"
                              to={"/pages/shipping-information"}
                            >
                              Shipping Information
                            </Link>
                            .
                            <div className="invalid-feedback">
                              You must agree before submitting.
                            </div>
                          </div>
                        </div>
                        <div className="secure-payment">
                          <img
                            src="/images/secure-payment.png"
                            width={433}
                            height={65}
                            alt=""
                          />
                        </div>
                        <div className="checkoutbtn">
                          <button type="submit" className="button alt">
                            Place order
                          </button>
                        </div>
                        <div className="checkoutbtn">
                          <Link to="/category/shop?orderBy=default">
                            Continue Shopping
                          </Link>
                        </div>
                      </div>
                    </Form>

                    <div className="form-stripe">
                      {details?.payment === "stripe" &&
                        clientSecret &&
                        stripePromise && (
                          <Elements
                            stripe={stripePromise}
                            options={{ clientSecret }}
                          >
                            <CheckoutForm
                              outOfStock={outOfStock}
                              selecteAddId={selecteAddId}
                              clientSecret={clientSecret}
                              stripePaymentData={stripePaymentData}
                            />
                          </Elements>
                        )}
                      {details?.payment === "stripe" && clientSecret === "" && (
                        <div
                          className="loading-div"
                          style={{ minHeight: "10px", padding: "10px 0" }}
                        >
                          <span>Loading...</span>
                        </div>
                      )}
                    </div>
                  </>
                ) : (
                  <>
                    <h2 className="text-center">{noCartItem}</h2>
                    <div className="placeorder-btn">
                      <div className="checkoutbtn">
                        <Link to="/category/shop?orderBy=default">
                          Continue Shopping
                        </Link>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
